import { toast } from 'sonner';

export const useToast = () => {
  const successToast = ({ title, description }: { title?: string; description?: string }) => {
    toast.success(title || 'Yay! Success 🎉', {
      description: description || 'Your request was successfully processed.',
      duration: 5000,
      className: 'bg-success-muted border border-success text-success',
      icon: '🎉',
    });
  };

  const infoToast = ({ title, description }: { title?: string; description: string }) => {
    toast.info(title || 'Info', {
      description: description || 'We hit a snag processing your request. Please try again.',
      duration: 3000,
      className: 'bg-info-muted border border-info text-info',
      icon: '📣',
    });
  };

  const warningToast = ({ title, description }: { title?: string; description: string }) => {
    toast.warning(title || 'Warning', {
      description: description || 'We hit a snag processing your request. Please try again.',
      duration: 3000,
      className: 'bg-warning-muted border border-warning text-warning',
      icon: '⚠️',
    });
  };

  const errorToast = ({ title, description }: { title?: string; description: string }) => {
    toast.error(title || 'Uh oh! Something went wrong 😞...', {
      description: description || 'We hit a snag processing your request. Please try again.',
      duration: 3000,
      className: 'bg-error-muted border border-destructive text-destructive',
      icon: '🚫',
    });
  };

  return { successToast, errorToast, infoToast, warningToast };
};
